import {
  Table as CSDTable,
  TableProps,
} from "@cloudscape-design/components-themed";
import { IExaminationTargetItems, LABELS } from "./constants";
import TableEmptyState from "../UI/TableEmptyState";
import { COMMON_LABELS } from "../default-constants";

interface ITable {
  items: IExaminationTargetItems[];
  nttFItems: IExaminationTargetItems[];
  isNttF: boolean;
}

const columnDefinitions: TableProps.ColumnDefinition<IExaminationTargetItems>[] =
  [
    {
      id: "examinationOrderTarget",
      header: LABELS.EXAMINATION_ORDER_TARGET,
      cell: (item: IExaminationTargetItems) => item.examinationOrderTarget,
    },
    {
      id: "vMTarget",
      header: COMMON_LABELS.BLANK,
      cell: (item: IExaminationTargetItems) =>
        item.vMTarget ? LABELS.DOT : COMMON_LABELS.BLANK,
      width: 40,
      maxWidth: 40,
      minWidth: 40,
    },
    {
      id: "examinationOrderDate",
      header: LABELS.EXAMINATION_ORDER_DATE,
      cell: (item: IExaminationTargetItems) => item.examinationOrderDate,
    },
    {
      id: "examinationAnswerDate",
      header: LABELS.EXAMINATION_ANSWER_DATE,
      cell: (item: IExaminationTargetItems) => item.examinationAnswerDate,
    },
    {
      id: "examinationStatus",
      header: LABELS.EXAMINATION_STATUS,
      cell: (item: IExaminationTargetItems) => item.examinationStatus,
    },
    {
      id: "posRegistrationOrderDate",
      header: LABELS.POS_REGISTRATION_ORDER_DATE,
      cell: (item: IExaminationTargetItems) => item.posRegistrationOrderDate,
    },
    {
      id: "posRegistrationAnswerDate",
      header: LABELS.POS_REGISTRATION_ANSWER_DATE,
      cell: (item: IExaminationTargetItems) => item.posRegistrationAnswerDate,
    },
    {
      id: "posRegistrationStatus",
      header: LABELS.POS_REGISTRATION_STATUS,
      cell: (item: IExaminationTargetItems) => item.posRegistrationStatus,
    },
    {
      id: "merchantNo",
      header: LABELS.MERCHANT_NO,
      cell: (item: IExaminationTargetItems) => item.merchantNo,
    },
    {
      id: "tenantMerchantNo",
      header: LABELS.TENANT_MERCHANT_NO,
      cell: (item: IExaminationTargetItems) => item.tenantMerchantNo,
    },
    {
      id: "accessKey",
      header: LABELS.ACCESS_KEY,
      cell: (item: IExaminationTargetItems) => item.accessKey,
    },
    {
      id: "secretKey",
      header: LABELS.SECRET_KEY,
      cell: (item: IExaminationTargetItems) => item.secretKey,
    },
  ];

/**
 * 審査依頼先一覧
 */
const Table = (props: ITable) => {
  const { items, nttFItems, isNttF } = props;

  return (
    <CSDTable
      columnDefinitions={columnDefinitions}
      items={isNttF ? nttFItems : items}
      empty={<TableEmptyState />}
      resizableColumns
    />
  );
};

export default Table;
